/**
 * Export app version
 */
export const appVersion = require("../../../../../package.json").version;
export const assetsVersion = require("../../../../../node_modules/@goodgamestudios/poker2-createjs-assets/package.json").version;

/**
 * @author Dominik
 */
export class PokerGameVersion {
    public static BUILD_NUMBER: number = 390;
    public static VERSION: string = "0.1";
    public static DATE: string = "201201311804";

    public static get versionText(): string {
        return "V" + 0.1 + " B" + 390;
    }
}
